import { createAsyncThunk } from '@reduxjs/toolkit';

import l10n from '../../shared/strings';
import showBatchOperationStartedToast from '../batchOperations/helpers/showBatchOperationStartedToast';
import { OPERATION_TYPES, RESULT } from '../batchOperations/constants';
import handleStoreDisconnectedError, {
  isStoreDisconnectedError,
} from './helpers/handleStoreDisconnectedError';

const strings = l10n.ACTIONS_TOOLBAR.PRODUCTS;

export const publishListingDrafts = createAsyncThunk(
  'products/publishListingDrafts',
  async ({
    productIds = [],
    variantIds = [],
    promoteProduct = false,
    channelName,
  }, {
    extra: {
      sdk, Toast, Logger,
    },
  }) => {
    try {
      const { data } = await sdk.products.publishListing(productIds, {
        variantIds,
        promoteProduct,
        background: true,
      });

      if (data?.batchId) {
        showBatchOperationStartedToast({
          batchId: data.batchId,
          status: data.status || RESULT.queued,
          total: data.total,
          operationType: data.operationType || OPERATION_TYPES.PUBLISH_DRAFTS,
          channelName,
        });
        return data;
      }

      Toast(strings.publishFailed, { type: 'error', autoClose: false });
      throw new Error('Publish drafts batch was not started');
    } catch (error) {
      if (isStoreDisconnectedError(error)) {
        handleStoreDisconnectedError({ Toast, error });
      } else {
        Toast(strings.publishFailed, { type: 'error', autoClose: false });
      }
      Logger.error(new Error('Bulk publish listing drafts failed'), { error }, [
        'PublishListingDraftsFailed',
        { errorMessage: error?.message || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(publishListingDrafts.rejected, (state, { error }) => {
    state.error = error?.message || 'Cannot publish selected drafts';
  });
};
